module.exports = __webpack_public_path__ + "img/retail_solution_bg_img01.a477dbfe.png";